<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="18">
        <!-- <div class="card kjfs">
          <p class="title">
            <i class="fa fa-th-large fa-lg"></i>
          </p>
            <ul>
           <! <li>
              <router-link to="/dataAnalysis" class="kjfs kjfs-purplee">
                <span>
                  <i class="fa fa-area-chart fa-2x"></i>
                </span>
                <span>大数据展示</span>
              </router-link>
            </li>

          </ul>
        </div>-->
      </el-col>
    </el-row>
    <div v-if="hidetype1" style="margin-bottom: -50px;">
      <el-row :gutter="20" class="row-pane">
        <el-col :span="24">
          <!-- <el-col :span="6"  >
                	<el-col :span="24" style="border-left: 3px solid #223341;" >
               	   	<el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
               	   		<i class="el-icon-user-solid"></i>  购票总数
               	   	</el-col>
                    <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #409EFF;" >{{ticketCount}}
                    </el-col>
                 </el-col>
	           </el-col>-->
          <el-col :span="6">
            <el-col :span="24" style="border-left: 3px solid #223341;">
              <el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
                <i class="el-icon-folder-checked"></i> {{ $t('home.Ordinarycard') }}     
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #409EFF;">{{ OrdinaryCard }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="6">
            <el-col :span="24" style="border-left: 3px solid #223341;">
              <el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
                <i class="el-icon-bank-card"></i> {{ $t('home.Storedcard') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #409EFF;">{{ StoreCard }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="6">
            <el-col :span="24" style="border-left: 3px solid #223341;">
              <el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
                <i class="el-icon-bank-card"></i> {{ $t('home.Membershipcard') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #409EFF;">{{ MembershipCard }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="6">
            <el-col :span="24" style="border-left: 3px solid #223341;">
              <el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
                <i class="el-icon-user"></i> {{ $t('home.Groupcard') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #409EFF;">{{ GroupCard }}
              </el-col>
            </el-col>
          </el-col>
        </el-col>

        <el-col :span="24" style=" margin-top: 5px;">
          <el-col :span="4" style="margin-top:10px;  margin-left: 10px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-money"></i> {{ $t('home.Amount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ amount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-top:10px;  margin-left: 30px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-s-marketing"></i> {{ $t('home.Cash') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ Cash }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-top:10px;  margin-left: 30px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-mobile"></i> {{ $t('home.Alipay') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ Alipay }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-top:10px;  margin-left: 30px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-mobile"></i> {{ $t('home.WeChat') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ WeChat }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-top:10px;  margin-left: 30px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-bank-card"></i> {{ $t('home.UnionPay') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ UnionPay }}
              </el-col>
            </el-col>
          </el-col>

        </el-col>
        <el-col :span="24" style=" margin-top: 5px;">
          <el-col :span="4" style="margin-top:10px;  margin-left: 10px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-s-finance"></i> {{ $t('home.Refund') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ Ramount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-top:10px;  margin-left: 30px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-s-marketing"></i> {{ $t('home.Cashrefunded') }}
              </el-col>
            </el-col>
            <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ RCash }}
            </el-col>
          </el-col>

          <el-col :span="4" style="margin-top:10px;  margin-left:30px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-mobile"></i> {{ $t('home.Alipayback') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ RAlipay }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-top:10px;  margin-left: 30px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-mobile"></i> {{ $t('home.RefundWechat') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ RWeChat }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-top:10px;  margin-left: 30px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-bank-card"></i> {{ $t('home.RefundUnionPay') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ RUnionPay }}
              </el-col>
            </el-col>
          </el-col>
        </el-col>
      </el-row>



    </div>

    <div v-if="hidetype2" style="margin-bottom: -25px; margin-top: -20px;">
      <el-row :gutter="20" class="row-pane">

        <el-col :span="24">
          <el-col :span="6">
            <el-col :span="24" style="border-left: 3px solid #223341;">
              <el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
                <i class="el-icon-user-solid"></i> {{ $t('home.todayEnterCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #409EFF;">{{ todayEnterCount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="6" style="border-left: 3px solid #223341;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
                <i class="el-icon-s-ticket"></i> {{ $t('home.todayOfflineTicketCount') }}
              </el-col>
              <el-col :span="22" style="font-weight: bold;font-size: 30px; color: #15B580;">{{ todayOfflineTicketCount }}
              </el-col>
            </el-col>

          </el-col>
          <el-col :span="6" style="border-left: 3px solid #223341;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
                <i class="el-icon-s-management"></i> {{ $t('home.todayOnlineTicketCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #78A2EA;">{{ todayOnlineTicketCount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="6" style="border-left: 3px solid #223341;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 20px; color: #15B5E9;">
                <i class="el-icon-s-ticket"></i> {{ $t('home.todayWeChatTicketCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #000000;">{{ todayWeChatTicketCount }}
              </el-col>
            </el-col>
          </el-col>

        </el-col>
        <el-col :span="24" style=" margin-top: 15px;">
          <el-col :span="4" style="margin-top:10px;  margin-left: 10px; border: 1px solid gainsboro;">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-s-check"></i> {{ $t('home.entercount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ enterCount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style=" margin-left:30px; margin-top: 10px;   border: 1px solid gainsboro; ">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-s-management"></i> {{ $t('home.groupTicketCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold; font-size: 30px; color: #15b5e9;">{{ 216491 }} <!--groupTicketCount-->
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-left: 30px;margin-top: 10px; border: 1px solid gainsboro ">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-s-management"></i> {{ $t('home.cardTicketCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;">{{ cardTicketCount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-left: 30px;margin-top: 10px;  border: 1px solid gainsboro ">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-s-management"></i> {{ $t('home.ordinaryTicketCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ ordinaryTicketCount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-left:30px;margin-top:10px;  border: 1px solid gainsboro">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #223341;">
                <i class="el-icon-s-management"></i> {{ $t('home.enterCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ ticketNum }}
              </el-col>
            </el-col>
          </el-col>
        </el-col>
        <el-col :span="24" style=" margin-top: 5px;">
          <el-col :span="4" style="margin-top: 10px;  margin-left: 10px;  border: 1px solid gainsboro ">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px;  color: #375573;">
                <i class="el-icon-s-management"></i> {{ $t('home.offlineTicketCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ offlineTicketCount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-left:30px;margin-top: 10px;  border: 1px solid gainsboro ">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #375573;">
                <i class="el-icon-s-management"></i> {{ $t('home.onlineTicketCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ onlineTicketCount }}
              </el-col>
            </el-col>
          </el-col>

          <el-col :span="4" style="margin-left:30px;margin-top: 10px;  border: 1px solid gainsboro ">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #375573;">
                <i class="el-icon-s-management"></i> {{ $t('home.weChatTicketCount') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ weChatTicketCount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-left:30px;margin-top: 10px;  border: 1px solid gainsboro ">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #375573;">
                <i class="el-icon-s-management"></i> {{ $t('home.zdj') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ terminalTicketCount }}
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="4" style="margin-left:30px;margin-top: 10px;  border: 1px solid gainsboro ">
            <el-col :span="24">
              <el-col :span="24" style="font-weight: bold;font-size: 14px; color: #375573;">
                <i class="el-icon-s-management"></i> {{ $t('home.dsf') }}
              </el-col>
              <el-col :span="24" style="font-weight: bold;font-size: 30px; color: #15b5e9;"> {{ onlineTicketCount }}
              </el-col>
            </el-col>
          </el-col>
        </el-col>
        <!-- <el-col :span="6">
                <el-row>
                    <el-col :span="2" style="width: 12px; height: 12px; background: #1890FF;
                        border-radius: 50%; margin: 20px 0 0 35px;"></el-col>
                    <el-col :span="22" style="width: 150px; height: 15px; font-size: 16px;
                        font-family: Alibaba PuHuiTi; font-weight: 400; color: #333333;
                        margin: 15px 0 0 10px;">本周销售总数</el-col>
                </el-row>
                 <el-row>
             				<el-col :span="24">
	                   	   	<el-col :span="2" style="width: 12px; height: 12px; background: #1890FF;
	                        border-radius: 50%; margin: 20px 0 0 35px;"></el-col>
	                        <el-col :span="22" style="width: 150px; height: 15px; font-size: 16px;
	                        font-family: Alibaba PuHuiTi; font-weight: 400; color: #333333;
	                        margin: 15px 0 0 10px;">销售普通卡:1252
	                        </el-col>
                     </el-col>
                    <el-col :span="24">
	                        <el-col :span="2" style="width: 12px; height: 12px; background: #1890FF;
	                        border-radius: 50%; margin: 20px 0 0 35px;">
	                        </el-col>
	                        <el-col :span="22" style="width: 150px; height: 15px; font-size: 16px;
	                        font-family: Alibaba PuHuiTi; font-weight: 400; color: #333333;
	                        margin: 15px 0 0 10px;">销售团体卡:1252
	                        </el-col>
                      </el-col>
                      <el-col :span="24">
	                         <el-col :span="2" style="width: 12px; height: 12px; background: #1890FF;
	                        border-radius: 50%; margin: 20px 0 0 35px;"></el-col>
	                        <el-col :span="22" style="width: 150px; height: 15px; font-size: 16px;
	                        font-family: Alibaba PuHuiTi; font-weight: 400; color: #333333;
	                        margin: 15px 0 0 10px;">销售会员卡:1252
	                        </el-col>
                      </el-col>
                      <el-col :span="24">
                         	 <el-col :span="2" style="width: 12px; height: 12px; background: #1890FF;
		                        border-radius: 50%; margin: 20px 0 0 35px;"></el-col>
		                        <el-col :span="22" style="width: 150px; height: 15px; font-size: 16px;
		                        font-family: Alibaba PuHuiTi; font-weight: 400; color: #333333;
		                        margin: 15px 0 0 10px;">销售储值卡:1252
		                        </el-col>
                        </el-col>
                	</el-row>
             	</el-col>-->
      </el-row>
    </div>

    <div ref="Chart1" id="Chart1" class="" style="width:33%;height: 290px;   cursor: pointer; float: left;">
    </div>
    <div ref="Chart2" id="Chart2" class="" style="width:33%;height: 290px;    cursor: pointer;float: left;">
    </div>
    <div ref="Chart4" id="Chart4" class="" style="width:33%;height:  290px;    cursor: pointer;float: left;">
    </div>
    <div ref="Chart3" id="Chart3" class="" style="width:33%;height: 290px;   cursor: pointer;float: left;">
    </div>

    <div ref="Chart5" id="Chart5" class="" style="width:33%;height: 290px; cursor: pointer;float: left;">
    </div>
    <div ref="Chart6" id="Chart6" class="" style="width:33%;height: 290px;   cursor: pointer;float: left;">
    </div>
  </div>
</template>

<script>

//import LineEcharts from "../../../components/ECharts/lineEcharts";

import echarts from "echarts";
import westeros from "../../../components/ECharts/theme/westeros";

export default {
  inject: ['reload'],
  name: "mainIndex",
  //mponents: { LineEcharts },
  data() {
    return {
      hidechart: false,
      hidetype1: false,
      hidetype2: false,
      cardTicketCount: 0,//会员卡张数
      enterCount: 0,// 入园人数
      ticketNum: 0,
      groupTicketCount: 0,//团体票张数
      offlineTicketCount: 0,//线下购票张数
      onlineTicketCount: 0,//线上购票张数
      ordinaryTicketCount: 0,//普通票张数
      todayEnterCount: 0,//当天入园人数
      todayOfflineTicketCount: 0,//当天线下购票张数
      todayOnlineTicketCount: 0,//当天线上购票张数
      todayWeChatTicketCount: 0,//当天公众号购票张数
      weChatTicketCount: 0,//公众号购票张数
      terminalTicketCount: 0,//终端机
      ticketCount: 0,
      OrdinaryCard: 0,
      MembershipCard: 0,
      StoreCard: 0,
      GroupCard: 0,
      RticketCount: 0,
      ROrdinaryCard: 0,
      RMembershipCard: 0,
      RStoreCard: 0,
      RGroupCard: 0,
      amount: 0,
      preferentialAmount: 0,
      Cash: 0,
      Alipay: 0,
      WeChat: 0,
      UnionPay: 0,
      Ramount: 0,
      RpreferentialAmount: 0,
      RCash: 0,
      RAlipay: 0,
      RWeChat: 0,
      RUnionPay: 0,
      hide1: false,
      hide2: false,
      hide3: false,
      hide4: false,
      passengerFlowList: "",
      provinceList: "",
      hide5: false
    }
  },
  mounted() {
    //this.selfAdaption();
    this.home();

  },

  methods: {

    chartInit1() {
      let ordinaryTicketCount = this.ordinaryTicketCount //普通
      let cardTicketCount = this.cardTicketCount //会员票
      let groupTicketCount = this.groupTicketCount//团体票
      let datalist = [];
      datalist.push(
        {
          value: ordinaryTicketCount,
          name: this.$t('home.Ordinarycard')
        },
        {
          value: cardTicketCount,
          name: this.$t('home.Membershipcard')
        },
        {
          value: groupTicketCount,
          name: this.$t('home.Storedcard')
        }
      )
      console.log(datalist)

      let Chart1 = this.$refs.Chart1;
      let myChart1 = echarts.init(Chart1, "westeros");
      myChart1.setOption({
        color: ['#28bee3', '#28e39a', '#5fea7f', '#0c74f4'],
        title: {
          text: this.$t('home.type'),
          textStyle: {}
        },
        tooltip: {
          show: true,
          transitionDuration: 0,//echart防止tooltip的抖动
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          x: "center",
          y: "bottom",
          data: [this.$t('home.Ordinarycard'), this.$t('home.Membershipcard'), this.$t('home.Storedcard')],
          textStyle: {
            color: "#000000"
          }
        },
        toolbox: {
          show: true,
          feature: {
            magicType: {
              show: true,
              type: ["pie", "funnel"],
              option: {
                funnel: {
                  x: "25%",
                  width: "70%",
                  funnelAlign: "left",
                  max: 1444
                }
              }
            }

          }
        },
        calculable: true,
        series: [
          {
            name: "",
            type: "pie",
            radius: "60%",
            center: ["50%", "52%"],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  textStyle: {
                    color: "#000000"
                  }
                },
                labelLine: {
                  show: true,
                  textStyle: {
                    color: "#000000"
                  }
                }
              },
              emphasis: {
                label: {
                  show: true,
                  position: "left",
                  textStyle: {
                    fontSize: "12",
                    fontWeight: "normal"
                  }
                }
              }
            },
            data: datalist
          }
        ]
      });



    },
    chartInit2() {
      let Chart2 = this.$refs.Chart2;
      let myChart2 = echarts.init(Chart2, "westeros");
      // 1. 指定图表的配置项和数据
      var option2 = {
        title: {
          text: this.$t('home.Ticketstatistics')
        },
        tooltip: {
          show: true,
          transitionDuration: 0, // echart防止tooltip的抖动
        },
        legend: {
          data: [this.$t('home.Volume')]
        },
        xAxis: {
          data: [this.$t('home.Membershipcard'), this.$t('home.Ordinarycard'), this.$t('home.Storedcard'), this.$t('home.Groupcard')]
        },
        yAxis: {},
        series: [{
          name: this.$t('home.Volume'),
          type: 'bar',
          data: [this.cardTicketCount, this.ordinaryTicketCount, 0, 0] // [5, 20, 36, 10]
        }]
      };
      myChart2.setOption(option2);

    },
    chartInit3() {
      this.chart = echarts.init(document.getElementById("Chart3"), "westeros");
      this.chart.setOption({
        title: {
          text: this.$t('home.Transactionanalysis'),
        },

        tooltip: {
          show: true,
          transitionDuration: 0,//echart防止tooltip的抖动
          trigger: "axis"
        },
        legend: {
          y: "bottom",
          data: [
            this.$t('home.Cash'), this.$t('home.WeChat'),
            this.$t('home.Alipay'), this.$t('home.UnionPay'), this.$t('home.Bought')]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true
        },
        toolbox: {
          feature: {
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [this.$t('home.Monday'), this.$t('home.Tuesday'), this.$t('home.Wednesday'),
          this.$t('home.Thursday'), this.$t('home.Friday'), this.$t('home.Saturday'), this.$t('home.Sunday')]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: this.$t('home.Cash'),
            type: "line",
            stack: this.$t('home.Total'),
            data: [0, 0, 0, 0, 0, 0] // [101, 22, 12, 33, 22, 123]
          },
          {
            name: this.$t('home.WeChat'),
            type: "line",
            stack: this.$t('home.Total'),
            data: [0, 0, 0, 0, 0, 0] // [101, 112, 102, 33, 22, 123]
          },
          {
            name: this.$t('home.Alipay'),
            type: "line",
            stack: this.$t('home.Total'),
            data: [0, 0, 0, 0, 0, 0] // [11, 12, 25, 33, 22, 223]
          },
          {
            name: this.$t('home.UnionPay'),
            type: "line",
            stack: this.$t('home.Total'),
            data: [0, 0, 0, 0, 0, 0] // [101, 15, 77, 39, 85, 123]
          },
          {
            name: this.$t('home.Bought'),
            type: "line",
            stack: this.$t('home.Total'),
            data: [0, 0, 0, 0, 0, 0] // [25, 35, 10, 30, 60, 42]
          }
        ]
      });
    },
    chartInit4() {
      // this.passengerFlowList=data.passengerFlowList;
      // this.provinceList=data.provinceList;
      this.chart = echarts.init(document.getElementById("Chart4"), "westeros");
      this.chart.setOption({
        color: ['#28bee3', '#28e39a', '#5fea7f', '#0c74f4'],
        title: {
          text: this.$t('home.Sourceanalysis'),
        },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c}"
        },
        toolbox: {
          feature: {
          }
        },
        calculable: true,
        legend: {
          x: 'center',
          y: 'bottom',
          data: [this.$t('home.OTA'), this.$t('home.OfflineWindow'),
          this.$t('home.account'), this.$t('home.Terminal')],

          textStyle: { //图例文字的样式
            color: '微软雅黑'

          }
        },

        series: [{
          name: 'Access to the resource',
          type: 'pie',
          radius: ['35%', '55%'],
          itemStyle: {
            normal: {
              label: {
                show: true,
                textStyle: {
                  color: '微软雅黑'
                }

              },
              labelLine: {
                show: true,
                textStyle: {
                  color: '微软雅黑'
                }

              }
            },
            emphasis: {
              label: {
                show: true,
                position: 'center',
                textStyle: {
                  fontSize: '14',
                  fontWeight: 'normal',

                }
              }
            }
          },
          data: [
            {
              name: this.$t('home.OTA'),
              value: this.onlineTicketCount
            },
            {
              name: this.$t('home.OfflineWindow'),
              value: this.offlineTicketCount
            },
            {
              name: this.$t('home.account'),
              value: 0
            },
            {
              name: this.$t('home.Terminal'),
              value: this.terminalTicketCount
            }

          ]

        }]
      });


    },
    chartInit5() {
      let passengerFlowList = this.passengerFlowList

      //this.provinceList=data.provinceList;
      this.chart = echarts.init(document.getElementById("Chart5"), "westeros");
      this.chart.setOption({
        title: {
          text: this.$t('home.visitorsflowrate'),
          itemGap: 20,
          color: '微软雅黑'
        },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c}"
        },
        grid: {
          x: 48,
          y: 45,
          x2: 5,
          y2: 20,
          borderWidth: 1
        },
        toolbox: {
          feature: {
          }
        },
        xAxis: {
          type: 'category',
          data: ['6:00-9:00', '9:00-12:00', '12:00-18:00', '18:00-22:00']
        },
        yAxis: {
          type: 'value'
        },
        series: [{

          //  data:[],
          data: passengerFlowList,
          type: 'line'
        }]
      });


    },
    chartInit6() {
      console.log(this.provinceList)
      var provinceList;
      if (this.provinceList == "" || this.provinceList == undefined) {
        var data = [{
          value: 0,
          name: "暂无"
        }, {
          value: 0,
          name: "暂无"
        }, {
          value: 0,
          name: "暂无"
        }, {
          value: 0,
          name: "暂无"
        }, {
          value: 0,
          name: "暂无"
        }]
        provinceList = data;
      } else {
        provinceList = this.provinceList;
      }
      console.log(provinceList)
      this.chart = echarts.init(document.getElementById("Chart6"), "westeros");
      this.chart.setOption({
        title: {
          text: this.$t('home.Touristtype'),
          subtext: ''
        },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c}"
        },
        toolbox: {
          feature: {
          }
        },
        legend: {
          data: [this.$t('home.Membershipcard'), this.$t('home.Ordinarycard'), this.$t('home.VIP'),
          this.$t('home.Groupcard'), this.$t('home.family')],
          orient: 'vertical',
          x: 'right',
          y: 'bottom'
        },
        calculable: true,
        series: [{
          name: '漏斗图',
          type: 'funnel',
          width: '60%',
          data: provinceList,
        }]
      });
    },
    home() {
      let storage = window.sessionStorage;
      let category = storage.getItem("category");
      if (category == 0) {
        this.indexadmin();
        this.hidetype2 = true;
      }
      if (category == 2) {
        this.sellorder();
        this.sell();
        this.hidetype1 = true;

        //this.echartslist1();
        //	this.echartslist2();
      }
      if (category == 1) {
        this.indexadmin();
        this.hidetype2 = true;

        // 	this.echartslist3();
      }
    },
    sellorder() {
      let storage = window.sessionStorage;
      let token = storage.getItem("token");
      let accountID = storage.getItem("userId");
      let operate = 1 //订单
      this.$axios({
        url: "/api/sell/dutyRecord",
        method: "post",
        data: {
          operate: operate,
          accountID: accountID,
          token: token
        },
        headers: {
          "authorization": token,

          "Content-Type": "application/json; charset=utf-8"
        }
      })
        .then(res => {
          console.log(res.data);
          let data = res.data;
          for (const i in data) {
            if (data[i].orderStatus == 1) { // 1购票  3 退票
              this.GroupCard = data[i].GroupCard;
              this.MembershipCard = data[i].MembershipCard;
              this.OrdinaryCard = data[i].OrdinaryCard;
              this.StoreCard = data[i].StoreCard;
              this.orderStatus = data[i].orderStatus;
              this.ticketCount = data[i].ticketCount;
            }
            if (data[i].orderStatus == 3) { // 1购票  3 退票
              this.RGroupCard = data[i].GroupCard;
              this.RMembershipCard = data[i].MembershipCard;
              this.ROrdinaryCard = data[i].OrdinaryCard;
              this.RStoreCard = data[i].StoreCard;
              this.RorderStatus = data[i].orderStatus;
              this.RticketCount = data[i].ticketCount;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });

    },
    sell() {
      let storage = window.sessionStorage;
      let token = storage.getItem("token");
      let scenicAreaID = storage.getItem("companyId")
      let zoneID = storage.getItem("zone")
      let userId = storage.getItem("userId")
      let accountID = storage.getItem("userId");
      let operate = 3 //
      this.$axios({
        url: "/api/sell/dutyRecord",
        method: "post",
        data: {
          operate: operate,
          scenicAreaID: scenicAreaID,
          accountID: userId,
          token: token
        },
        headers: {
          "authorization": token,

          "Content-Type": "application/json; charset=utf-8"
        }
      })
        .then(res => {

          console.log(res.data);
          let data = res.data;

          if (data.length == 0) {
            this.passengerFlowList = "";
            this.provinceList = "";

            this.chartInit1();
            this.chartInit2();
            this.chartInit3();
            this.chartInit4();
            this.chartInit5();
            this.chartInit6();
          }
          for (const i in data) {
            if (data[i].orderStatus == 1) { // 1购票  3 退票
              this.amount = data[i].amount;
              this.preferentialAmount = data[i].preferentialAmount;
              this.Cash = data[i].Cash;
              this.Alipay = data[i].Alipay;
              this.WeChat = data[i].WeChat;
              this.UnionPay = data[i].UnionPay;
            }
            if (data[i].orderStatus == 3) { // 1购票  3 退票
              this.Ramount = data[i].amount;
              this.RpreferentialAmount = data[i].preferentialAmount;
              this.RCash = data[i].Cash;
              this.RAlipay = data[i].Alipay;
              this.RWeChat = data[i].WeChat;
              this.RUnionPay = data[i].UnionPay;
            }

            /*this.Samount = parseFloat(this.amount - this.Ramount).toFixed(2);
            this.SpreferentialAmount= parseFloat(this.preferentialAmount -this.RpreferentialAmount).toFixed(2);
            this.SCash=	parseFloat(this.Cash - this.RCash).toFixed(2);
            this.SAlipay=parseFloat(this.Alipay - this.RAlipay).toFixed(2);
            this.SWeChat= parseFloat(this.WeChat- this.RWeChat).toFixed(2);
            this.SUnionPay=	parseFloat(this.UnionPay- this.RUnionPay).toFixed(2) ;*/


            this.passengerFlowList = data.passengerFlowList;
            this.provinceList = data.provinceList;

            this.chartInit1();
            this.chartInit2();
            this.chartInit3();
            this.chartInit4();
            this.chartInit5();
            this.chartInit6();
          }
        })
        .catch(err => {
          console.log(err);
        });

    },
    indexadmin() {
      let storage = window.sessionStorage;
      let scenicAreaID = storage.getItem("companyId")
      let zoneID = storage.getItem("zone")
      let userId = storage.getItem("userId")
      let token = storage.getItem("token")
      this.$axios({
        url: "/api/homePage",
        method: "get",
        params: {
          token: token,
          scenicAreaID: scenicAreaID,
          zoneID: zoneID,
          accountID: userId,
        },
        headers: {
          "authorization": token
        }
      })
        .then(res => {
          console.log(res.data);

          let data = res.data;
          if (data.length == 0) {
            this.passengerFlowList = "";
            this.provinceList = "";
            this.chartInit1();
            this.chartInit2();
            this.chartInit3();
            this.chartInit4();
            this.chartInit5();
            this.chartInit6();
          }

          this.cardTicketCount = data.cardTicketCount,//会员卡张数
            this.enterCount = data.enterCount// 入园人数

          this.groupTicketCount = data.groupTicketCount//团体票张数
          this.ordinaryTicketCount = data.ordinaryTicketCount//普通票张数
          this.todayEnterCount = data.todayEnterCount//当天入园人数
          this.todayOfflineTicketCount = data.todayOfflineTicketCount//当天线下购票张数
          this.todayOnlineTicketCount = data.todayOnlineTicketCount//当天线上购票张数
          this.todayWeChatTicketCount = data.todayWeChatTicketCount//当天公众号购票张数
          this.weChatTicketCount = data.weChatTicketCount//公众号购票张数
          this.offlineTicketCount = data.offlineTicketCount//线下购票张数
          this.onlineTicketCount = data.onlineTicketCount//线上购票张数


          if (data.ticketNum) {
            this.ticketNum = data.ticketNum//使用票数
          }
          if (data.terminalTicketCount) {
            this.terminalTicketCount = data.terminalTicketCount//使用票数
          }

          this.passengerFlowList = data.passengerFlowList;
          this.provinceList = data.provinceList;

          this.chartInit1();
          this.chartInit2();
          this.chartInit3();
          this.chartInit4();
          this.chartInit5();
          this.chartInit6();
        })
        .catch(err => {
          console.log(err);
        });

    },
  }
};
</script>

<style lang="scss">
$top: top;
$bottom: bottom;
$left: left;
$right: right;
$leftright: (
  $left,
  $right
);
$pinkk: #eec2d3;
$bluee: #409eff;
$yelloww: #f4d884;
$grennn: #89dda0;
$purplee: #78a2eacb;
$lightBluee: #99ccff;
$red: red;

$list: bluee pinkk yelloww grennn purplee lightBluee red;
$list1: $bluee $pinkk $yelloww $grennn $purplee $lightBluee $red;

%shadow {
  background: #fff;
  -webkit-box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.2);
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.2);
  border-color: rgba(0, 0, 0, 0.2);

  .title {
    font-size: 14px;
    padding: 10px;

    i {
      margin-#{$right}: 5px;
    }
  }
}

@mixin flex($direction: row, $content: space-between) {
  display: flex;
  flex-direction: $direction;
  justify-content: $content;
}

.card {
  color: #666;
  @extend %shadow;

  ul {
    @include flex;

    li {
      flex: 1;

      a {
        color: #666666;
        align-items: center;
        padding-#{$top}: 20px;
        padding-#{$bottom}: 20px;
        @include flex(column);

        span {
          height: 44px;
        }

        .num {
          line-height: 44px;
          font-size: 42px;
          color: $bluee;
          margin: 0px;
        }
      }

      .kjfs-bluee {
        color: $bluee;
      }

      .kjfs-pinkk {
        color: $pinkk;
      }

      .kjfs-yelloww {
        color: $yelloww;
      }

      .kjfs-grennn {
        color: $grennn;
      }

      .kjfs-purplee {
        color: $purplee;
      }

      .kjfs-lightBluee {
        color: $lightBluee;
      }

      .kjfs-red {
        color: $red;
      }

      &:hover {
        .kjfs-bluee {
          color: #ffffff;
          background: $bluee;
        }

        .kjfs-pinkk {
          color: #ffffff;
          background: $pinkk;
        }

        .kjfs-yelloww {
          color: #ffffff;
          background: $yelloww;
        }

        .kjfs-grennn {
          color: #ffffff;
          background: $grennn;
        }

        .kjfs-purplee {
          color: #ffffff;
          background: $purplee;
        }

        .kjfs-lightBluee {
          color: #ffffff;
          background: $lightBluee;
        }

        .kjfs-red {
          color: #ffffff;
          background: $red;
        }
      }
    }
  }

  .table {
    padding: 21px;

    p {
      height: 52px;
      line-height: 52px;
      border: 1px solid #cccccc;
      overflow: hidden;
      border-#{$top}: none;
      @include flex(null, start);

      &:first-child {
        border-#{$top}: 1px solid #cccccc;
      }

      .tit {
        width: 90px;
        min-width: 90px;
        height: 100%;
        text-align: center;
        border-#{$right}: 1px solid #cccccc;
        margin-#{$right}: 18px;
      }

      span.gitbox {
        flex: 1;
        height: 100%;
        overflow: hidden;
        @include flex(row, start);

        a {
          &:first-child {
            margin-#{$right}: 30px;
          }
        }
      }
    }
  }
}

#lineEcharts {
  margin-#{$top}: 30px;
  padding-#{$top}: 30px;
  @extend %shadow;
}


.row-pane {
  height: 300px !important;
  margin: 20px 0 0 0 !important;
}

.col-1 {
  background-color: white;
  height: 300px !important;
  width: 49.6%;
  float: left;
}

.col-2 {
  background-color: white;
  height: 300px !important;
  width: 49.6%;
  float: right;
}

#chartmainline1,
#chartmainline2,
#chartmainline3 {
  height: 350px;
  width: 600px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/system/index/index/mainIndex.vue